import React, { Component } from 'react';
import LongText from '../Utils/LongText';

class Background extends Component {
  
render() {
    const { activeButton } = this.props;
    return (
       <div style={{ all: 'unset' }}>
                {activeButton === 'about3' && (
                    <div className="about-right-section-page">
                        <h1>Background</h1>
                    <div className="about-right-section-text">
                        <LongText maxLength={1} byParagraphs>
                            <p>
                                I grew up in the suburbs of Atlanta, where, as an
                                inquisitive, creative kid I was constantly learning about
                                science, making art and building things. In college at
                                Georgia State University, I applied these traits towards a
                                bachelors in computer science, where I learned how to design
                                systems working as a software engineer. After graduating in
                                2015, I worked over the years at several large companies in
                                the Metro-Atlanta area, including LexisNexis, Autotrader,
                                and AT&T. I then later moved to Los Angeles California,
                                where I worked as a senior software engineer at NASAs Jet
                                Propulsion lab supporting climate research.
                            </p>
                            <p>
                                It was during my time at JPL, that my interests began to
                                shift from software systems to social systems and
                                individuals as I began to realize how, many of our
                                scientific issues, such as climate change, rest upon human
                                behavior and motivations. During the pandemic, I decided to
                                go back to school to study psychology enrolling at Sofia
                                University. I choose to go into the subfield of
                                Transpersonal Psychology which seeks to study how we can
                                derive a sense of meaning through our connection to
                                something greater than ourselves, whether that be through a
                                passion for the environment, belonging to a community, being
                                part of a cause, or having a spiritual practice.
                            </p>
                            <p>
                                I believe through an approach to being grounded in something
                                larger we can approach life’s problems from a holistic
                                perspective. Through this perspective we can create
                                ethically sound systems, and transform people on an
                                individual level. I believe having an appreciation for the
                                mystery of life's beauty can give one a renewed sense of
                                purpose and meaning. It leads to big picture thinking, as
                                I've seen in a variety of contexts such in my work on
                                climate research, personal experiences through meditation,
                                art, and studies at Sofia.
                            </p>
                        </LongText>
                    </div>
                    </div>
                )}
       </div> 
    );
  }
}

export default Background;